import { RefObject, createContext, createRef } from 'react';

export const ScrollContainerContext = createContext<{
	hasScrollbar: boolean;
	ref: RefObject<HTMLElement>;
}>({ hasScrollbar: false, ref: createRef() });
